import { ErrorBoundary } from '@sentry/react'

const ErrorBoundaryForgotPassword = (props) => {
    return (
        <ErrorBoundary
            fallback={
                <h1>
                    Couldn't load forgot password view. Something went wrong.
                    Check Sentry for logs
                </h1>
            }
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default ErrorBoundaryForgotPassword
